var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px"},style:({ width: '100%', height: '60vh'}),attrs:{"id":"mains"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }